<template>
  <b-list-group-item>
    <div class="d-none d-xl-block">
      <b-row>
        <b-col cols="1">{{ transaction.transaction_date | toUSDateFormat(true) }}</b-col>
        <b-col cols="1">{{ transaction.order_number }} <span v-if="transaction.split_payment" class="px-2" style="color:blue; font-size:small;">Split</span></b-col>
        <b-col cols="2">{{ transaction.customer_name }}</b-col>
        <b-col cols="3">{{ transaction.transaction_number }}</b-col>
        <b-col cols="1">{{ transaction.transaction_amount | toCurrency }}</b-col>
        <b-col cols="1">
          <b-button
            v-if="transaction.transaction_receipt"
            variant="primary"
            target="_blank"
            rel="noopener noreferrer"
            :href="transaction.transaction_receipt">
            Click
          </b-button>
        </b-col>

        <b-col cols="1" v-if="transaction.captured || this.tipdata['transtip']">{{ currentTip | toCurrency }}</b-col>
        <b-col cols="1" v-else><b-button variant="primary" @click="tipModalSelect=true">Add Tip</b-button></b-col>
        <TipModal
          v-if="tipModalSelect"
          :transaction_amount="transaction.transaction_amount"
          :transaction_number="transaction.transaction_number"
          @emit-post-tip="tipModalClose">
        </TipModal>

        <b-col cols="1" v-if="transaction.refunded==0.00"><b-button variant="primary" @click="refundOrCapture()">Refund</b-button></b-col>
        <b-col cols="1" v-else>{{ transaction.refunded | toCurrency}}</b-col>

        <b-col cols="1" v-if="transaction.payment_method==1">Cash</b-col>
        <b-col cols="1" v-if="transaction.payment_method==2">Card - Web</b-col>
        <b-col cols="1" v-if="transaction.payment_method==3">Card - Terminal</b-col>
        <b-col cols="1" v-if="transaction.payment_method==4">Gift Card</b-col>
      </b-row>
    </div>

<!-- MOBILE SCREEN -->
    <div class="d-xl-none" style="font-size: 90%;">
      <b-row>
        <b-col cols="3">{{ transaction.transaction_date | toUSDateFormat(true) }}</b-col>
        <b-col cols="5">
          <a v-b-toggle :href="'#trans-details'+transaction.id" @click.prevent>
            {{ transaction.order_number }} <span v-if="transaction.split_payment" class="px-2" style="color:blue; font-size:small;">Split</span>
          </a>
        </b-col>
        <b-col cols="2">{{ transaction.transaction_amount | toCurrency }}</b-col>

        <b-col cols="2" v-if="transaction.captured || this.tipdata['transtip']">{{ currentTip | toCurrency }}</b-col>
        <b-col cols="2" v-else><b-button variant="primary" size="sm" @click="tipModalSelect=true">Add Tip</b-button></b-col>
        <TipModal
          v-if="tipModalSelect"
          :transaction_amount="transaction.transaction_amount"
          :transaction_number="transaction.transaction_number"
          @emit-post-tip="tipModalClose">
        </TipModal>
      </b-row>

      <b-collapse :id="'trans-details'+transaction.id">
        <b-row>
          <b-col cols="3"><b>Trans #</b></b-col>
          <b-col>
            {{ transaction.transaction_number }}
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3"><b>Customer</b></b-col>
          <b-col>{{ transaction.customer_name }}</b-col>
        </b-row>
        <b-row>
          <b-col cols="3"><b>PayType</b></b-col>
          <b-col v-if="transaction.payment_method==1">Cash</b-col>
          <b-col v-if="transaction.payment_method==2">Card - Web</b-col>
          <b-col v-if="transaction.payment_method==3">Card - Terminal</b-col>
        </b-row>
        <b-row>
          <b-col v-if="transaction.refunded==0.00"><b-button variant="primary" size="sm" @click="refundOrCapture()">Refund</b-button></b-col>
          <b-col v-else><b>Refunded: </b>{{ transaction.refunded | toCurrency}}</b-col>

          <b-col>
            <b-button
              v-if="transaction.transaction_receipt"
              variant="primary"
              target="_blank"
              rel="noopener noreferrer"
              size="sm"
              :href="transaction.transaction_receipt">
              Receipt
            </b-button>
          </b-col>
        </b-row>
      </b-collapse>

      <b-modal :id="'refund-modal'+transaction.id" @ok="confirmRefund()" title="Refund">
        <b-row>
          <b-col cols="7">
            <b-form-checkbox size="lg" v-model="fullRefund" name="full-refund" switch>Full Refund</b-form-checkbox>
          </b-col>
          <b-col cols="4">
            <b-form-input :disabled="fullRefund" v-model="refundedAmount"></b-form-input>
          </b-col>
        </b-row>
        <b-alert dismissible :show="refundTypeAlert">Not a Number!</b-alert>
      </b-modal>
    </div>

  </b-list-group-item>
</template>

<script>
import TipModal from '@/components/TipModal.vue'
export default {
  name: 'TransactionInfo',
  components: {
    TipModal
  },
  props: ['transaction'],
  data () {
    return {
      tipModalSelect: false,
      tip: 0,
      tipdata: {
        'paymentintent': this.transaction.stripe_payment_intent_id,
        'transtotal': this.transaction.transaction_amount,
        'transid': this.transaction.id,
        'paymethod': this.transaction.payment_method
      },
      setRefundAmount: this.transaction.transaction_amount,
      fullRefund: true,
      refundTypeAlert: false
    }
  },

  watch: {
    setRefundAmount: function() {
      if (this.setRefundAmount) {
        Number(this.setRefundAmount) ? this.refundTypeAlert=false : this.refundTypeAlert=true;
      }
    },
  },

  computed: {
    refundedAmount: {
        get: function() {
          if (this.fullRefund) {
            return this.transaction.transaction_amount;
          } else {
            return this.setRefundAmount;
          }
        },
        set: function(value) {
          this.fullRefund=false;
          this.setRefundAmount = value;
        }
    },

    currentTip: function() {
      if (this.tipdata['transtip']) {
        return this.tipdata['transtip'];
      } else {
        return this.transaction.tip;
      }
    }
  },

  methods: {
    emitFetchTransactions() {
      this.$emit('emit-fetch-transactions');
    },

    refundOrCapture() {
      if (this.transaction.captured==false) {
        this.$bvModal.msgBoxConfirm('Payment not yet captured. Do you want to capture payment first before refunding?' )
          .then(value => {
            if (value==true) {
              this.$emit('emit-spinner');
              this.postTipToServer()
            }
          })
          .catch(err => {
            console.log(err);
          })
      } else {
        this.$bvModal.show('refund-modal'+this.transaction.id)
      }
    },

    tipModalClose(tipamount, tipentered) {
      // close the tip modal and reset component access
      this.tipModalSelect = false;
      // if tip confirmed, post tip amount, otherwise do nothing
      if (tipentered) {
        this.tipdata['transtip']=tipamount;
        this.postTipToServer();
      }
    },

    async postTipToServer() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();
      // Use Axios to make a call to the API
      try {
        const { data } = await this.$api.post("capture-payment", this.tipdata, {
          headers: {
            Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
          }
        });
        if (data.paymentIntent.status=="succeeded") {
          setTimeout(function () { this.emitFetchTransactions() }.bind(this), 2000)
        } else {
          console.log(data);
        }
      } catch (err) {
        console.log(err.response.data);
        var desc = 'There was a problem posting the tip. Please try again later.';
        if (err.response.data.description=='amount_too_large') {
          desc = 'The tip amount is too large for this transaction. Try again with a lower amount.';
        }
        this.$bvToast.toast(desc, {
          title: 'Tip Post Failed',
          solid: true,
          variant: 'danger',
          toaster: 'b-toaster-bottom-right'
        })
      }
    },

    confirmRefund() {
      this.$bvModal.msgBoxConfirm('Refund ' + this.$options.filters.toCurrency(this.refundedAmount) + ' from transaction ' + this.transaction.transaction_number + '?' )
        .then(value => {
          if (value==true) {
            this.refundTransaction()
          }
        })
        .catch(err => {
          console.log(err);
        })
    },

    async refundTransaction() {
      const refundData = {
        "transid": this.transaction.id,
        "refunded": this.refundedAmount
      }
      const token = await this.$auth.getTokenSilently();
      try {
        const { data } = await this.$api.post("refund-payment", refundData, {
          headers: {
            Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
          }
        });
        if (data.paymentIntent.status=="succeeded") {
          this.$emit('emit-spinner')
          setTimeout(function () { this.emitFetchTransactions() }.bind(this), 2000)
        } else {
          console.log(data);
        }
      } catch (err) {
        console.log(err);
        var desc = 'There was a problem attempting the refund. Please try again later.';
        if (err.response.data.description=='amount_too_large') {
          desc = 'The refund amount is too large for this transaction. Try again with a lower amount.';
        }
        this.$bvToast.toast(desc, {
          title: 'Refund Failed',
          solid: true,
          variant: 'danger',
          toaster: 'b-toaster-bottom-right'
        })
      }
    },

  }
}
</script>

<style>
</style>
